import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'toggleIcon', 'wrapper']
  static classes = ['open']

  connect() {
    this.expanded = false
  }

  toggle(event) {
    const button = event.currentTarget
    const answerBlock = button.closest('.group')

    const content = answerBlock.querySelector(
      '[data-answer-guidance-toggle-target="content"]'
    )
    const wrapper = answerBlock.querySelector(
      '[data-answer-guidance-toggle-target="wrapper"]'
    )
    const icon = answerBlock.querySelector(
      '[data-answer-guidance-toggle-target="toggleIcon"]'
    )

    if (content && icon && wrapper) {
      this.toggleGuidance(
        content,
        icon,
        wrapper,
        button,
        !wrapper.classList.contains('open')
      )
    }
  }

  // Handle keyboard events for guidance toggle buttons
  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      this.toggle(event)
    }
  }

  toggleGuidance(content, icon, wrapper, button, notExpanded) {
    if (notExpanded) {
      content.classList.add('py-2')
      wrapper.classList.add('open')
      icon.classList.add('rotate-180')
      button.setAttribute('aria-expanded', 'true')
    } else {
      content.classList.remove('py-2')
      wrapper.classList.remove('open')
      icon.classList.remove('rotate-180')
      button.setAttribute('aria-expanded', 'false')
    }
  }

  toggleAll(event) {
    this.expanded = !this.expanded

    this.contentTargets.forEach((el, index) => {
      const icon = this.toggleIconTargets[index]
      const wrapper = this.wrapperTargets[index]
      // Find the button for this guidance element
      const button = wrapper.closest('.guidance').querySelector('button[data-action*="answer-guidance-toggle#toggle"]')
      this.toggleGuidance(el, icon, wrapper, button, this.expanded)
    })

    const toggle = event.currentTarget
    const knob = toggle.querySelector('span')

    toggle.setAttribute('aria-checked', this.expanded)
    toggle.classList.toggle('bg-primary-700', this.expanded)
    toggle.classList.toggle('bg-gray-200', !this.expanded)
    knob.classList.toggle('translate-x-5', this.expanded)
    knob.classList.toggle('translate-x-0', !this.expanded)
  }
}
